import { render } from "./collapes.vue?vue&type=template&id=7f5451cb&scoped=true"
import script from "./collapes.vue?vue&type=script&lang=js"
export * from "./collapes.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7f5451cb"

export default script